module.exports = __webpack_public_path__ + "img/Z86Q_14.319a980a.jpg";